import { fetchTagById, fetchTagBySlug } from './http/TagHttp';
import { TagModel } from './models/TagModel';
import { normalizeTag } from './normalizers/TagNormalizer';

export const getTagIdBySlug = async (slug: string): Promise<string> => {
    const response = await fetchTagBySlug(slug);
    return response && response.length > 0 ? response[0].id : 'n/a';
};

export const getTagBySlug = async (slug: string): Promise<TagModel | null> => {
    try {
        const id = await getTagIdBySlug(slug);
        const response = await fetchTagById(id);
        return normalizeTag(response);
    } catch (e) {
        return null;
    }
};
